export const PLATFORM_NAME_MAX_LENGTH = 100;
export const PLATFORM_URL_MAX_LENGTH = 500;
export const JWT_EXPIRES_IN = "24h";

export enum Role {
  UNRESTRICTED = "unrestricted",
  RESTRICTED = "restricted",
}
